<template>
  <su-page title="查询结果页">
    <el-row class="mt30" slot="content">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch"
               label-width="68px">
        <el-form-item label="姓名" prop="name">
          <el-input
              v-model="queryParams.name"
              placeholder="姓名"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="证件号码" prop="certificateNumber">
          <el-input
              v-model="queryParams.certificateNumber"
              placeholder="请输入"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="flex al-cn cl333 f13 mtb20">
<!--        <div>考试时间：{{exam_time || '&#45;&#45;'}}</div>
        <div class="ml30">成绩有效期：{{end_time || '&#45;&#45;'}}</div>-->
      </div>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{backgroundColor:'#F3F4F8'}">
        <el-table-column prop="name" label="姓名" min-width="70"></el-table-column>
        <el-table-column prop="cert_no" label="证件号" min-width="170"></el-table-column>
        <el-table-column prop="coursea" label="科目一">
          <template slot-scope="scope">
            <span v-if="scope.row.coursea == -1">未参与</span>
            <span v-else>{{ scope.row.coursea }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="courseb" label="科目二">
          <template slot-scope="scope">
            <span v-if="scope.row.courseb == -1">未参与</span>
            <span v-else>{{ scope.row.courseb }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coursec" label="普通话">
          <template slot-scope="scope">
            <span v-if="scope.row.coursec == -1">未参与</span>
            <span v-else>{{ scope.row.coursec }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="coursed" label="外语">
          <template slot-scope="scope">
            <span v-if="scope.row.coursed == -1">未参与</span>
            <span v-else>{{ scope.row.coursed }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_pass" label="是否合格">
          <template slot-scope="scope">
            <span v-if="scope.row.is_pass == 1">合格</span>
            <span v-else>不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="exam_time" label="考试时间" width="100"></el-table-column>
        <el-table-column prop="end_time" label="成绩有效期" width="100"></el-table-column>
      </el-table>
    </el-row>
  </su-page>
</template>
<script>

import {getExamResults} from "@/api/api";
import {mapState} from 'vuex'

export default {
  name: "scoreInquiry",
  data() {
    return {
      // 列表加载
      loading: false,
      // 显示搜索条件
      showSearch: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
      },
      tableData: [],
      exam_time:'', // 考试时间
      end_time:'', // 成绩有效期
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {

  },
  mounted() {
    this.getList()
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    },
    /** 查询辨症列表 */
    getList() {
      this.loading = true;
      getExamResults(this.queryParams).then(response => {
        if (response.status === 200) {
          this.tableData = response.data.list || [];
          this.exam_time = response.data.exam_time;
          this.end_time = response.data.end_time;
        }
        this.loading = false;
      });
    },
  }
}
</script>


<style scoped lang="scss">

</style>
